import toastNotification from "./toastNotification";

function addRemovefavoritePrograms(element) {
  let attributes = {
    id: element.getAttribute('data-id'),
    sch_id: element.getAttribute('data-sch_id'),
    url: element.getAttribute('data-url'),
    source: element.getAttribute('data-source')
  };

  return function (e) {
    e.preventDefault();

    // Verify that the id for program favorites is available
    if (typeof attributes.id === 'undefined' || attributes.id === null || attributes.id === 'null' || attributes.id.trim() === '') {
      return false;
    }

    // Verify that the url for schools favorites is available
    if (typeof attributes.url === 'undefined' || attributes.url === null || attributes.url === 'null' || attributes.url.trim() === '') {
      return false;
    }

    let formData = new FormData();
    formData.set('program_id', attributes.id);
    formData.set('school_id', attributes.sch_id);
    formData.set('source', attributes.source);

    fetch(attributes.url, {
      method: 'POST',
      mode: "cors",
      credentials: "same-origin",
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData
    })
      .then(response => response.json())
      .then(function (result) {

        if (typeof result.status === 'undefined' || result.status === null || result.status === 'null') {

          // Set the custom message from the result as notification
          if (typeof result.message !== 'undefined' && result.message !== null && result.message !== 'null' && result.message.trim() !== '') {
            return toastNotification(result.message, 'error');
          }

          // Set a general message when a custom message is not available
          return toastNotification('An error occured whille attempting to store the information for your favorite school', 'error');
        }

        // Get counter in both desktop and mobile
        const counter = document.querySelector('[data-element="favorite-programs-count"]');
        const counterMob = document.querySelector('[data-element="favorite-programs-count-mob"]');
        const dropdown = document.querySelector('[data-element="favorites-programs-dropdown"]');
        let count = Number(counter?.textContent);


        // ADD PROGRAM
        // Handle the result when the program was added as favorite 
        if (result.status === true) {

          // If We have to - redirect user to different page
          if (result.redirect && result.redirect.trim() !== '') {
            return window.location.href = result.redirect;
          }

          let dropdownItem = document.createElement("li");
          element.classList.add('active');

          // Update content of the Favorites dropdown in header
          dropdownItem.classList.add('flexy');
          dropdownItem.setAttribute('data-element', 'favorite-program');
          dropdownItem.setAttribute('data-id', attributes.id);
          dropdownItem.innerHTML = result.program;
          dropdown.appendChild(dropdownItem);
          dropdownItem.querySelector('[data-action="favorite-program"]').addEventListener('click', addRemovefavoritePrograms(dropdownItem.querySelector('svg')))

          // Hide "No items" element
          dropdown.querySelector('.no-items').classList.add('hidden');

          // Change counter
          ;
          counter.textContent = ++count;
          counterMob.textContent = ++count;

          // Set the custom message from the response as notification
          if (typeof result.message !== 'undefined' && result.message !== null && result.message !== 'null' && result.message.trim() !== '') {
            return toastNotification(result.message, 'success');
          }

          // Set a general message when a custom message is not available
          return toastNotification('The program was added to your favorites successfully', 'success');
        }


        // REMOVE PROGRAM
        // Handle the response when the program was removed as favorite
        if (result.status === false) {

          element.classList.remove('active');

          // If removing is from header and program is in program list
          const programCard = document.querySelector(`main [data-id="${attributes.id}"]`);
          if (programCard) {
            programCard.classList.remove('active')
          }

          // Remove from dropdown in header
          let dropdownItem = dropdown.querySelector('[data-element="favorite-program"][data-id="' + attributes.id + '"]');
          dropdownItem.remove();

          // Change counter
          counter.textContent = --count;
          counterMob.textContent = --count;

          // Show "No items" element in dropdown
          if (dropdown.children.length == 2) {
            dropdown.querySelector('.no-items').classList.remove('hidden');
          }

          // // Remove class from Favorite button in Profile page
          // document.querySelector('.school-heading .main-info .info a[data-id="' + attributes.id + '"]').classList.remove('active')

          // // Hide school info if the deletion is initialized from Fav tab in account
          // if (element.getAttribute('data-account') == 'account') {
          //   let container = element.parentElement.parentElement.parentElement;
          //   console.log(container);
          //   container.style.height = '0px';

          //   container.addEventListener('transitionend', function () {
          //     container.classList.remove('active');
          //   }, {
          //     once: true
          //   });
          // }

          // Set the custom message from the response as notification
          if (typeof result.message !== 'undefined' && result.message !== null && result.message !== 'null' && result.message.trim() !== '') {
            return toastNotification(result.message, 'success');
          }

          // Set a general message when a custom message is not available
          return toastNotification('The program was removed from your favorites successfully', 'success');

        }
      })
      .catch(function (error) {
        console.log('error', error)
        return toastNotification(error.message, 'error');
      });
  }
}

export default function addOrRemoveFromFavorites() {

  // toastNotification('An error occured whille attempting to store the information for your favorite school', 'error');
  // let attributes = {};
  const favoriteBtns = Array.from(document.querySelectorAll('[data-action="favorite-program"]'));

  favoriteBtns.forEach(function (el) {

    el.addEventListener('click', addRemovefavoritePrograms(el))

  });

}